import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/contato/ContatoClient.tsx");
